import baseConstants from './constants.base'

const constants = {
  ...baseConstants,
  backendHost:
    process.env.REACT_APP_SIMPLESAT_API_URL ||
    process.env.STORYBOOK_API_URL ||
    'https://api.simplesat.io',
  surveyHost: `https://${process.env.REACT_APP_SIMPLESAT_SURVEY_URL || 'survey.simplesat.io'}`,
  intercomAppID: process.env.REACT_APP_SIMPLESAT_INTERCOM_APP_ID,
  dropboxClientId: process.env.REACT_APP_DROPBOX_CLIENT_ID,
  stripeApiKey: process.env.REACT_APP_STRIPE_API_KEY,
  intercomAppClientId: process.env.REACT_APP_INTERCOM_APP_CLIENT_ID,
  webEmbedScriptURL: process.env.REACT_APP_EMBED_SCRIPT_URL,
  webEmbedPreviewSurveyToken: process.env.REACT_APP_WEB_EMBED_PREVIEW_SURVEY_TOKEN,
  workOsClientId: process.env.REACT_APP_WORKOS_CLIENT_ID || 'client_01H5HH2JTC1YPFKT7CFSQFC3NE',
  demoHostname: process.env.REACT_APP_DEMO_HOSTNAME || 'demo.simplesat.io',
  demoUserId: process.env.REACT_APP_DEMO_USER_ID || '184498',
  widgetPresets: {
    carouselPresetsUrl:
      process.env.REACT_APP_WIDGET_CAROUSEL_PRESETS ||
      'https://cdn.simplesat.io/config/carouselPresets.json',
    gridPresetsUrl:
      process.env.REACT_APP_WIDGET_GRID_PRESETS ||
      'https://cdn.simplesat.io/config/gridPresets.json',
    masonryPresetsUrl:
      process.env.REACT_APP_WIDGET_MASONRY_PRESETS ||
      'https://cdn.simplesat.io/config/masonryPresets.json',
    popupBoxPresetsUrl:
      process.env.REACT_APP_WIDGET_POPUP_BOX_PRESETS ||
      'https://cdn.simplesat.io/config/popupBoxPresets.json',
    scorePresetsUrl:
      process.env.REACT_APP_WIDGET_SCORE_PRESETS ||
      'https://cdn.simplesat.io/config/scorePresets.json',
  },
  onboardingPreviewSurveyUrl:
    process.env.REACT_APP_ONBOARDING_PREVIEW_SURVEY_URL ||
    'https://survey-dev.simplesat.io/?init=eyJwcmV2aWV3IjogInRydWUiLCAiY2xpZW50X2VtYWlsIjogInRlc3RlckBleGFtcGxlLmNvbSIsICJzdXJ2ZXlfZXhwaXJlZCI6IGZhbHNlLCAic3VydmV5X2V4cGlyZWRfZGF0ZSI6ICIiLCAiYXV0aG9yX2lkIjogbnVsbCwgImNvbXBhbnlfaWQiOiAxLCAic3VydmV5X3Rva2VuIjogIjA0SFo2TEh5QWFFbTJjNERvamx6SkdCNURfRjNaczRRSDlndVZfRFB2ODgiLCAidGlja2V0X2lkIjogInk4UmhoSzFLUFZrIiwgImFzc2lnbmVlIjogbnVsbCwgInN1cnZleV90eXBlIjogImdlbmVyaWNfZW1iZWQiLCAicmVsYXRlZF9mZWVkYmFja19ldmVudF9pZCI6IG51bGwsICJ2YWx1ZSI6ICI0IiwgImN1cnJlbnRfc3RlcCI6IDEsICJ1c2VfZXhwZXJpbWVudF9mZWF0dXJlIjogdHJ1ZX0=&preview=true',
}

export default constants



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/config/constants.prod.js